/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 12:24 pm
 * Last Modified: Wednesday, 24-08-14 12:29 pm, by Roger
 */

const Twitter = () => {
  return <svg fill="none" viewBox="0 0 73 72" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="Twitter" data-sentry-source-file="Twitter.tsx">
      <g clipPath="url(#clip0_5280_2607)" data-sentry-element="g" data-sentry-source-file="Twitter.tsx">
        <path d="M36.4781 1.86568C17.6273 1.86568 2.34375 17.1493 2.34375 36C2.34375 54.8507 17.6273 70.1343 36.4781 70.1343C55.3288 70.1343 70.6124 54.8507 70.6124 36C70.6124 17.1493 55.3288 1.86568 36.4781 1.86568Z" stroke="white" strokeMiterlimit="10" strokeWidth="3.73134" data-sentry-element="path" data-sentry-source-file="Twitter.tsx" />
        <path d="M40.2088 32.9104L54.8207 15.9254H51.358L38.6715 30.6716L28.5372 15.9254H16.8506L32.1715 38.2239L16.8506 56.0373H20.3133L33.7088 40.4627L44.4103 56.0373H56.0969L40.2013 32.9104H40.2088ZM21.5595 18.5298H26.8804L51.358 53.5448H46.0372L21.5595 18.5298Z" fill="white" data-sentry-element="path" data-sentry-source-file="Twitter.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="Twitter.tsx">
        <clipPath id="clip0_5280_2607" data-sentry-element="clipPath" data-sentry-source-file="Twitter.tsx">
          <rect fill="white" height="72" transform="translate(0.477539)" width="72" data-sentry-element="rect" data-sentry-source-file="Twitter.tsx" />
        </clipPath>
      </defs>
    </svg>;
};
export default Twitter;